import React, { useEffect, useState } from "react";
import { getAllGateways } from "../../../../redux/user/actions";
import { useDispatch, useSelector } from "react-redux";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import { Navigate, useNavigate } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import DepositImg from "../../../../assets/images/icons/dc.png";
import bankImg from "../../../../assets/images/icons/bank.png";
import { getActiveBankDetails } from "../../../../redux/app/actions";
import BackIcon from "../../../../assets/svg/BackIcon";
import RightArrow from "../../../../assets/images/icons/right-chevron.png";
import { Container } from "react-bootstrap";
import Bitcoin from "../../../../assets/images/icons/pay-partners/bitcoin.png";
import Ethereum from "../../../../assets/images/icons/pay-partners/ethereum.png";
import Tether from "../../../../assets/images/icons/pay-partners/tether.png";
import Binance from "../../../../assets/images/icons/pay-partners/binance.png";
import UsdCoin from "../../../../assets/images/icons/pay-partners/usdcoin.png";
import GtwInfoSection from "../../../components/gateways/GtwInfoSection";
import DepositGateway from "./depositGateway";

const GatewaysList = () => {
  const dispatch = useDispatch();
  const [gatewaysList, setGatewaysList] = useState([]);
  const [activeGtw, setActiveGtw] = useState(null);
  const { bankDetails } = useSelector((state) => state.app);
  const { user } = useSelector((state) => state.auth);
  const isDemoUser =
    process.env.REACT_APP_DEMO_USER_ID &&
    user?.userName === process.env.REACT_APP_DEMO_USER_ID;

  const isAutoGatewayExist = gatewaysList?.deposits?.some(
    (f) => f?.type === "auto"
  );
  const navigate = useNavigate();

  useEffect(() => {
    loadGtwsFromServer();
    dispatch(getActiveBankDetails());
  }, []);

  const handleGatewayClick = (item) => {
    // dispatch(setSelectedGateway(item));
    // navigate(`/deposit/${item.id}`);
    setActiveGtw(item?.id);
  };

  const handleBankTransferClick = () => {
    navigate(`/deposit/bank_transfer`);
  };

  const loadGtwsFromServer = async () => {
    const response = await getAllGateways();
    if (response && response?.data?.data?.data) {
      setActiveGtw(response?.data?.data?.data?.deposits?.[0]?.id);
      setGatewaysList(response?.data?.data?.data);
    }
  };

  return (
    <>
      {isDemoUser && <Navigate to="/" />}
      <HeaderAfterLogin />

      <main className="main">
        <Container>
          <div className="headingSec">
            {/* <h4 className="depositHeading">
              Deposit Select a payment system to top up your account
            </h4> */}

            <div className="back-link" onClick={() => navigate(-1)}>
              <BackIcon /> Back
            </div>
          </div>

          <div className="gatewaySection">
            {gatewaysList?.deposits?.length > 1 && (
              <div className="gatewaypart">
                <Tabs
                  defaultActiveKey={isAutoGatewayExist ? "Deposit" : "Deposit"}
                  id="uncontrolled-tab-example"
                  className=""
                >
                  <Tab eventKey="Deposit" title="Payments">
                    {gatewaysList?.deposits
                      ?.sort((a, b) => a?.order - b?.order)
                      .map((item, index) => {
                        return (
                          <div
                            className="cards1"
                            onClick={() => {
                              handleGatewayClick(item);
                            }}
                            key={index}
                          >
                            <div className="card-icon">
                              <img src={DepositImg} />
                            </div>
                            <p style={{ color: "#fff" }}>{item?.name}</p>
                            <img
                              src={RightArrow}
                              alt="arrow"
                              className="arrow"
                            />
                          </div>
                        );
                      })}
                  </Tab>
                </Tabs>
              </div>
            )}

            {/* <div className="pay-partner">
              <ul>
                <li>
                  <img src={Bitcoin} alt="bitcoin" />
                </li>
                <li>
                  <img src={Ethereum} alt="ethereum" />
                </li>
                <li>
                  <img src={Tether} alt="tether" />
                </li>
                <li>
                  <img src={Binance} alt="binance" />
                </li>
                <li>
                  <img src={UsdCoin} alt="usdcoin" />
                </li>
              </ul>
            </div> */}
          </div>
          {/* <GtwInfoSection /> */}
          {activeGtw && <DepositGateway activeGtw={activeGtw} />}
          {/* <h3 className="InstantWithdraw">INSTANT WITHDRAWALS WITHOUT KYC</h3> */}
        </Container>
      </main>
    </>
  );
};
export default GatewaysList;
